import { render } from "./singlePatient.vue?vue&type=template&id=cad14998&scoped=true"
import script from "./singlePatient.vue?vue&type=script&lang=js"
export * from "./singlePatient.vue?vue&type=script&lang=js"

import "./singlePatient.vue?vue&type=style&index=0&id=cad14998&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cad14998"]])

export default __exports__